import { initializeApp } from "firebase/app";

export const config = {
  apiKey: "AIzaSyCyZInaizgxhtsdLHkpyqt4hzwqa2VI8cc",
  authDomain: "auth.sharepark.net",
  projectId: "sharepark-251906",
  storageBucket: "sharepark-251906.appspot.com",
  messagingSenderId: "417484639508",
  appId: "1:417484639508:web:12046e9bf0bed82cfec601",
  measurementId: "G-TM2PND970H",
};

const app = initializeApp(config);

export default app;
